module.exports = {
  input: require('./input'),
  output: require('./output')
}



//////////////////
// WEBPACK FOOTER
// ./~/bitcoinjs-lib/src/templates/witnesspubkeyhash/index.js
// module id = 390
// module chunks = 0